import { render } from "./CxReset.vue?vue&type=template&id=e5503db0&scoped=true&ts=true"
import script from "./CxReset.vue?vue&type=script&lang=ts"
export * from "./CxReset.vue?vue&type=script&lang=ts"

import "./CxReset.vue?vue&type=style&index=0&id=e5503db0&lang=less&scoped=true"

import exportComponent from "/home/ec2-user/workspace/_ui_production_production-1.59.1/microfrontends/conx-ui-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5503db0"]])

export default __exports__